import classes from './SubHeader.module.css'

const SubHeader = (props) => {
  return (
    <div className={classes.sub_header}>
      <div className={classes.sub_title}>{props.title}</div>
      <img
        className={classes.sub_underline_1}
        src={"/assets/decorations/underline_1.svg"}
        alt="new"
      />
    </div>
  );
};

export default SubHeader;
